import { AxiosError } from 'axios'
import { createDomain, sample } from 'effector'
import { t } from 'i18next'
import { Car, OsgopMassImportResult } from '~/shared/api'
import { snackbarEnqueued } from '~/shared/lib/notifications'

const domain = createDomain('pages.cars.list.importOsgopTemplate')

type OsgopMassImportError = AxiosError<{
  errors?: { detail?: string }[]
  message?: string
  detail?: string
}>

const getErrorMessage = (error: OsgopMassImportError) => {
  const data = error.response?.data
  const details = data?.errors
    ?.map((item) => item.detail)
    .filter(Boolean)
    .join(', ')

  return details || data?.detail || data?.message || t('alert.server error')
}

export const osgopMassImportFx = domain.createEffect<
  File,
  OsgopMassImportResult,
  OsgopMassImportError
>({
  async handler(file) {
    return await Car.osgopMassImport(file)
  },
})

sample({
  clock: osgopMassImportFx.failData,
  fn(error) {
    return {
      message: getErrorMessage(error),
      variant: 'error' as const,
    }
  },
  target: [snackbarEnqueued],
})
